var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.192.988c-1.84 1.39-3.74 2.7-5.62 4.05-1.35 1-2.72 1.92-4.09 2.87a33.083 33.083 0 00-4.14 3.1c-1.43 1.38-.11 2.71.95 3.77a40.851 40.851 0 004.27 3.6c1.35 1 2.77 1.92 4.15 2.89 1.38.97 2.59 2 3.91 2.92 1.32.92 2.56-1.22 1.26-2.15l-7.18-5.17a43.197 43.197 0 01-3.66-2.94 12.452 12.452 0 00-1.64-1.61c-.28-.42-.37-.27-.29.46.146-.126.296-.246.45-.36l1-.8c3.89-2.91 8-5.53 11.87-8.47 1.26-1 0-3.14-1.26-2.16h.02z"
  })));
}
export default SvgArrow;